<template>
  <Page>
    <div class="patient-selection">
      <div class="patient-selection__title">
        You are entering as
        <br />
      </div>
      <div class="patient-selection__container">
        <form
          ref="form"
          method="post"
          :action="action"
        >
          <div v-if="companies.length > 1">
            <div class="patient-selection__dropdown-container">
              <Dropdown
                :items="companiesData"
                label="Company"
                name="PatientId"
                :value="firstCompany.PatientId"
                autosuggest
                defaultInput="Select patient company"
                auto-qa-id="patient-selection-dropdown"
                :onChange="onChange"
              />
            </div>
            <div class="patient-selection__button-container">
              <Button
                variant="outlined"
                :loading="loading.button"
                auto-qa-id="patient-selection-continue-button"
                :onClick="submitForm"
              >
                Continue as patient
              </Button>
            </div>
          </div>
          <div v-else>
            <input
              type="hidden"
              name="PatientId"
              :value="firstCompany.PatientId"
            />
            <div class="patient-selection__button-container">
              <Button
                variant="outlined"
                :loading="loading.button"
                auto-qa-id="patient-selection-continue-button"
                :onClick="submitForm"
              >
                Continue as {{ firstCompany.Text }} patient
              </Button>
            </div>
          </div>

          <input
            v-if="userCode"
            type="hidden"
            name="UserCode"
            :value="userCode"
          />

          <input
            type="hidden"
            name="externalCompany"
            :value="external"
          />

          <input
            v-if="returnUrl"
            type="hidden"
            name="ReturnUrl"
            :value="returnUrl"
          />

          <input
            v-if="platform"
            type="hidden"
            name="Platform"
            :value="platform"
          />

          <input
            type="hidden"
            name="__RequestVerificationToken"
            :value="antiForgeryToken"
          />
        </form>
      </div>
      <div
        class="patient-selection__enter-as-patient-container"
        v-if="showEnterAsEmployee"
      >
        <div class="patient-selection__enter-as-patient-container">
          or enter as
          <div
            class="patient-selection__enter-as-patient-link"
            @click="enterAsEmployee"
          >
            employee
          </div>
        </div>

        <input
          v-if="returnUrl"
          type="hidden"
          name="ReturnUrl"
          :value="returnUrl"
        />
      </div>
    </div>
  </Page>
</template>

<script src="./PatientSelection.js"></script>

<style src="./PatientSelection.scss" lang="scss" scoped></style>
